export const getAgentSettingsUrl = '/gateway/api/devai-core/public/v2/settings/get';
export const setAgentSettingsUrl = '/gateway/api/devai-core/public/v2/settings/set';
